if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      // Runs on first load and again whenever facets.js re-renders #ProductGridContainer (filter/sort change)
      connectedCallback() {
        this.nextUrl = this.dataset.nextUrl;
        // Deep-linked pages (e.g. ?page=3) keep the regular pagination so earlier pages stay reachable
        if (!this.nextUrl || this.dataset.currentPage !== '1') return;

        this.grid = this.parentElement.querySelector('#product-grid');
        this.pagination = this.querySelector('.pagination-wrapper');
        this.spinner = this.querySelector('.infinite-scroll__spinner');
        if (!this.grid || !('IntersectionObserver' in window)) return;

        if (this.pagination) this.pagination.classList.add('hidden');

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) this.loadNextPage();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      async loadNextPage() {
        if (this.loading || !this.nextUrl) return;
        this.loading = true;
        if (this.spinner) this.spinner.classList.remove('hidden');

        try {
          // Section Rendering API: fetch only this section instead of the whole page
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url.toString());
          if (!response.ok) throw new Error(`Failed to load ${url}: ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          // The grid was replaced (filter/sort change) while this request was in flight
          if (!this.isConnected) return;

          const items = Array.from(html.querySelectorAll('#product-grid > .grid__item'));
          if (!items.length) throw new Error('No products found in response');

          items.forEach((item) => item.classList.add('scroll-trigger--cancel'));
          this.grid.append(...items);

          // Keep the hidden pagination in sync so the error fallback continues from the right page
          const nextPagination = html.querySelector('.pagination-wrapper');
          if (this.pagination && nextPagination) this.pagination.innerHTML = nextPagination.innerHTML;

          const nextElement = html.querySelector('infinite-scroll');
          this.nextUrl = nextElement ? nextElement.dataset.nextUrl : null;

          if (this.nextUrl) {
            // Re-observe so the next page loads right away if the end of the grid is still in view
            this.observer.unobserve(this);
            this.observer.observe(this);
          } else {
            this.observer.disconnect();
          }
        } catch (error) {
          console.error(error);
          // Fall back to regular pagination
          this.observer.disconnect();
          if (this.pagination) this.pagination.classList.remove('hidden');
        } finally {
          this.loading = false;
          if (this.spinner) this.spinner.classList.add('hidden');
        }
      }
    }
  );
}
